/**
 * Obnova po novém nasazení.
 *
 * Otevřená stránka ze starší verze webu po kliknutí stahuje kód podstránky,
 * který na serveru po novém nasazení už není (soubory mají v názvu hash).
 * Dřív se stránka obnovila jen JEDNOU za relaci prohlížeče – při dalším
 * nasazení zůstalo bílé okno a návštěvník musel obnovit ručně.
 *
 * Teď: při chybě načtení kódu stránku obnovíme (na adrese, kam návštěvník
 * mířil), nejvýš jednou za 10 s – kdyby server opravdu nefungoval, nezacyklí se to.
 */
export const CHUNK_ERROR = /ChunkLoadError|Loading chunk|Loading CSS chunk|dynamically imported module|Importing a module script failed|Failed to fetch dynamically imported/i;

const KEY = 'sk_chunk_reload_at';
const MIN_GAP_MS = 10000;

export function isChunkError(err) {
  return CHUNK_ERROR.test(String((err && (err.message || err.name)) || err || ''));
}

// Vrací true, pokud se stránka právě obnovuje
export function reloadForNewVersion() {
  let last = 0;
  try { last = Number(sessionStorage.getItem(KEY)) || 0; } catch { /* blokované úložiště */ }
  if (Date.now() - last < MIN_GAP_MS) return false;
  try { sessionStorage.setItem(KEY, String(Date.now())); } catch { /* noop */ }
  window.location.reload();
  return true;
}

// Chyby mimo React (dynamický import knihovny, lazy komponenta mimo ErrorBoundary)
export function installChunkErrorHandlers() {
  const onError = (reason) => { if (isChunkError(reason)) reloadForNewVersion(); };
  window.addEventListener('error', (e) => onError(e.error || e.message));
  window.addEventListener('unhandledrejection', (e) => onError(e.reason));
}
